/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { WorkplaceLocation } from './';
import {
    WorkplaceLocationFromJSON,
    WorkplaceLocationFromJSONTyped,
    WorkplaceLocationToJSON,
} from './';

/**
 * 
 * @export
 * @interface WorkplacePreferences
 */
export interface WorkplacePreferences {
    /**
     * 
     * @type {boolean}
     * @memberof WorkplacePreferences
     */
    isRemoteOnly: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkplacePreferences
     */
    isWillingToTravel: boolean;
    /**
     * 
     * @type {number}
     * @memberof WorkplacePreferences
     */
    principalWorkLocationSearchRadius: number;
    /**
     * 
     * @type {Array<WorkplaceLocation>}
     * @memberof WorkplacePreferences
     */
    alternativeWorkLocations: Array<WorkplaceLocation>;
    /**
     * 
     * @type {Array<string>}
     * @memberof WorkplacePreferences
     */
    travelLocations: Array<string>;
}

/**
 * Check if a given object implements the WorkplacePreferences interface.
 */
export function instanceOfWorkplacePreferences(value: object): value is WorkplacePreferences {
    if (!('isRemoteOnly' in value) || value['isRemoteOnly'] === undefined) return false;
    if (!('isWillingToTravel' in value) || value['isWillingToTravel'] === undefined) return false;
    if (!('principalWorkLocationSearchRadius' in value) || value['principalWorkLocationSearchRadius'] === undefined) return false;
    if (!('alternativeWorkLocations' in value) || value['alternativeWorkLocations'] === undefined) return false;
    if (!('travelLocations' in value) || value['travelLocations'] === undefined) return false;
    return true;
}

export function WorkplacePreferencesFromJSON(json: any): WorkplacePreferences {
    return WorkplacePreferencesFromJSONTyped(json, false);
}

export function WorkplacePreferencesFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkplacePreferences {
    if (json == null) {
        return json;
    }
    return {
        
        'isRemoteOnly': json['isRemoteOnly'],
        'isWillingToTravel': json['isWillingToTravel'],
        'principalWorkLocationSearchRadius': json['principalWorkLocationSearchRadius'],
        'alternativeWorkLocations': ((json['alternativeWorkLocations'] as Array<any>).map(WorkplaceLocationFromJSON)),
        'travelLocations': json['travelLocations'],
    };
}

export function WorkplacePreferencesToJSON(value?: WorkplacePreferences | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'isRemoteOnly': value['isRemoteOnly'],
        'isWillingToTravel': value['isWillingToTravel'],
        'principalWorkLocationSearchRadius': value['principalWorkLocationSearchRadius'],
        'alternativeWorkLocations': ((value['alternativeWorkLocations'] as Array<any>).map((v) => WorkplaceLocationToJSON(v))),
        'travelLocations': value['travelLocations'],
    };
}

